import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import I18n from 'i18n-js';
import { getUserCountryCodeFromState } from 'selectors/app-selector';
import OverlayBody from '../overlay-body';
import styles from './styles.less';

const DeliveryGuaranteeTncPanel = ({ onClose }) => {
  const countryCode = useSelector(getUserCountryCodeFromState);
  const src = `https://www.grab.com/${countryCode.toLowerCase()}/app/ge-insurance`;
  return (
    <OverlayBody
      showHeader
      showTitle
      title={I18n.t('v2.anytimeBooking.insurance.tncHeader')}
      showClose
      onClose={onClose}
    >
      <iframe
        src={src}
        title={I18n.t('v2.anytimeBooking.insurance.tncHeader')}
        className={styles.tncIframe}
      />
    </OverlayBody>
  );
};

DeliveryGuaranteeTncPanel.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default DeliveryGuaranteeTncPanel;
